import React, {Component} from 'react';
// import { stackedChart } from 'util/fusionChartManager';
// import { greyShade, white } from '../../../../../styles/colorCharts';
import {ButtonDropdown, ButtonGroup, DropdownMenu, DropdownToggle} from 'reactstrap';
import Button from 'material-ui/Button';
import {getDevicesData, refreshDevicesData} from 'util/aws-manager';
import {Checkbox, CheckboxGroup} from 'react-checkbox-group';

import SymbioticMarkerClusterer from './Components/SymbioticMarkerClusterer';
import CardBox from 'components/CardBox';

class Devices extends Component {
    stateToggle = () => {
        this.setState({
            stateDropDownOpen: !this.state.stateDropDownOpen,
        })
    };
    regionDropDownOpen = () => {
        this.setState({
            regionDropDownOpen: !this.state.regionDropDownOpen,
        })
    };
    sdpDropDownOpen = () => {
        this.setState({
            sdpDropDownOpen: !this.state.sdpDropDownOpen,
        })
    };
    techDropDownOpen = () => {
        this.setState({
            techDropDownOpen: !this.state.techDropDownOpen,
        })
    };
    roleDropDownOpen = () => {
        this.setState({
            roleDropDownOpen: !this.state.roleDropDownOpen,
        })
    };

    refreshData = () => {
        refreshDevicesData().then(() => {
            this.getData();
        });
    };

    getData = () => {
        getDevicesData(this.state.selectedStates, this.state.mapBounds).then((deviceData) => {
            this.setState({deviceData: JSON.parse(deviceData)});
        }).catch(e => {
            console.error("Error Fetching device Data", e);
        });
    };

    stateChanged = (selected) => {
        this.setState({selectedStates: selected}, () => {
            this.getData();
        });
    };

    onBoundsChanged = (bounds) => {
        this.setState({mapBounds: bounds ? [bounds.getSouthWest(), bounds.getNorthEast()] : []});
        this.getData();
    };

    getPercentDevices = () => {
        return this.state.deviceData.Summary.TotalFilteredDevices !== undefined && this.state.deviceData.MetaData.TotalDevices !== undefined ?
            this.state.deviceData.Summary.TotalFilteredDevices === 0 ? 0 :
                this.state.deviceData.Summary.TotalFilteredDevices === this.state.deviceData.MetaData.TotalDevices ? 100 :
                    this.state.deviceData.MetaData.TotalDevices > 0 ? (this.state.deviceData.Summary.TotalFilteredDevices / this.state.deviceData.MetaData.TotalDevices * 100).toFixed(2) : 0 : 0;
    };

    getPercentTechOnsite = () => {
        return this.state.deviceData.Summary.TotalFilteredTechOnsite !== undefined && this.state.deviceData.MetaData.TotalTechOnsite !== undefined ?
            this.state.deviceData.Summary.TotalFilteredTechOnsite === 0 ? 0 :
                this.state.deviceData.Summary.TotalFilteredTechOnsite === this.state.deviceData.MetaData.TotalTechOnsite ? 100 :
                    this.state.deviceData.MetaData.TotalTechOnsite > 0 ? (this.state.deviceData.Summary.TotalFilteredTechOnsite / this.state.deviceData.MetaData.TotalTechOnsite * 100).toFixed(2) : 0 : 0;
    };

    getPercentActiveNotifications = () => {
        return this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion !== undefined && this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion !== undefined ?
            this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion === 0 ? 0 :
                this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion === this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion ? 100 :
                    this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion > 0 ? (this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion / this.state.deviceData.MetaData.TotalDevicesWithActiveNotificaion * 100).toFixed(2) : 0 : 0;
    };

    getPercentClosedNotifications = () => {
        return this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion !== undefined && this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion !== undefined ?
            this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion === 0 ? 0 :
                this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion === this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion ? 100 :
                    this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion > 0 ? (this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion / this.state.deviceData.MetaData.TotalDevicesWithClosedNotificaion * 100).toFixed(2) : 0 : 0;
    };

    constructor() {
        super();
        this.state = {
            stateDropDownOpen: false,
            regionDropDownOpen: false,
            sdpDropDownOpen: false,
            techDropDownOpen: false,
            roleDropDownOpen: false,
            selectedStates: [],
            mapBounds: [],
            deviceData: {}
        };
    }

    componentDidMount() {

        this.getData();

        // let devices = this;
        // const categorie = [
        //     {
        //         "category": [
        //             {
        //                 "label": ""
        //             }
        //         ]
        //     }];
        // const categories = [
        //     {
        //         "category": [
        //             {
        //                 "label": "Telstra"
        //             },
        //             {
        //                 "label": "Optus"
        //             },
        //             {
        //                 "label": "Lend Lease"
        //             },
        //             {
        //                 "label": "Other"
        //             }
        //         ]
        //     }
        // ];
        // const accessType = [
        //     {
        //         "category": [
        //             {
        //                 "label": "Residential"
        //             },
        //             {
        //                 "label": "Business"
        //             },
        //         ]
        //     }
        // ];
        // const sdpRspData = [
        //     {
        //         "seriesname": "Good",
        //         "data": [
        //             {
        //                 "value": "30",
        //                 displayValue: "30% Good",
        //             },
        //             {
        //                 "value": "26",
        //                 displayValue: "26% Good",
        //             },
        //             {
        //                 "value": "27",
        //                 displayValue: "27% Good",
        //             },
        //             {
        //                 "value": "37",
        //                 displayValue: "37% Good",
        //             }
        //         ]
        //     },
        //     {
        //         "seriesname": "Bad",
        //         "data": [
        //             {
        //                 "value": "64",
        //                 displayValue: "64% Bad",
        //             },
        //             {
        //                 "value": "59",
        //                 displayValue: "59% Bad",
        //             },
        //             {
        //                 "value": "61",
        //                 displayValue: "61% Bad",
        //             },
        //             {
        //                 "value": "75",
        //                 displayValue: "75% Bad",
        //             }
        //         ]
        //     }
        // ];
        // const dataset = [{
        //     seriesname: "Good",
        //     data: [{
        //         displayValue: `${30}% Good`,
        //         value: 30,
        //     },
        //     ]
        // },
        //     {
        //         seriesname: "Bad",
        //         data: [{
        //             displayValue: `${70}% Bad`,
        //             value: 70,
        //         },
        //         ]
        //     },
        // ]
        // stackedChart("gaschart", dataset, categorie, 100, greyShade);
        // stackedChart("floodingChart", dataset, categorie, 100, greyShade);
        // stackedChart("securityChart", dataset, categorie, 100, greyShade);
        // stackedChart("techOnSite", dataset, categorie, 100, greyShade);
        // stackedChart("sdpChart", sdpRspData, categories, 400, white);
        // stackedChart("deviceDistributionChart", sdpRspData, categories, 320, white);
        // stackedChart("deviceSplitByAccessType", sdpRspData, accessType, 200, white);
    }

    render() {
        return (
            <div className="row devices-page">
                <div className="col-12">
                    <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
                        <div className="col-12 col-sm-2 col-lg-2">
                            <h1 className="mb-0">Devices</h1>
                        </div>
                        <div className="col-12 col-sm-10 col-lg-10">
                            <ButtonGroup className="d-flex" vertical={this.props.isVertical}>
                                <ButtonDropdown className="btn-width mr-1" isOpen={this.state.stateDropDownOpen} toggle={this.stateToggle}>
                                    <DropdownToggle className="bg-secondary text-white" caret>
                                        State
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <CheckboxGroup
                                            checkboxDepth={2}
                                            name="states"
                                            value={this.state.selectedStates}
                                            onChange={this.stateChanged}>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="NSW"/>NSW</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="QLD"/>QLD</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="VIC"/>VIC</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="SA"/>SA</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="WA"/>WA</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="NT"/>NT</label>
                                            <label className="dropdown-item"><Checkbox className="mr-2" value="TAS"/>TAS</label>
                                        </CheckboxGroup>
                                    </DropdownMenu>
                                </ButtonDropdown>

                                {/* <ButtonDropdown className="btn-width" isOpen={this.state.regionDropDownOpen} toggle={this.regionDropDownOpen}>
                            <DropdownToggle className=" bg-secondary text-white" caret>
                                Region
                                </DropdownToggle>
                            <DropdownMenu>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Region1</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Region2</a>
                            </DropdownMenu>
                        </ButtonDropdown>

                        <ButtonDropdown className="btn-width" isOpen={this.state.sdpDropDownOpen} toggle={this.sdpDropDownOpen}>
                            <DropdownToggle className=" bg-secondary text-white" caret>
                                SDP
                                </DropdownToggle>
                            <DropdownMenu>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Telstra</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Optus</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Lend Lease </a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Broadspectrum </a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Fulton Hogan </a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Downer </a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    ISGM</a>
                            </DropdownMenu>
                        </ButtonDropdown>

                        <ButtonDropdown className="btn-width" isOpen={this.state.techDropDownOpen} toggle={this.techDropDownOpen}>
                            <DropdownToggle className=" bg-secondary text-white" caret>
                                Technology
                                </DropdownToggle>
                            <DropdownMenu>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1 checkbox"
                                        type="checkbox"
                                    />
                                    FTTN</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    FTTP</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    FTTC</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    HFC</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Fixed Wireless</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Satellite</a>
                            </DropdownMenu>
                        </ButtonDropdown>

                        <ButtonDropdown className="btn-width" isOpen={this.state.roleDropDownOpen} toggle={this.roleDropDownOpen}>
                            <DropdownToggle className=" bg-secondary text-white" caret>
                                Role
                                </DropdownToggle>
                            <DropdownMenu>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Role1</a>
                                <a className="dropdown-item">
                                    <input
                                        className="mr-1"
                                        type="checkbox"
                                    />
                                    Role2</a>
                            </DropdownMenu>
                        </ButtonDropdown> */}
                                <Button className="jr-btn btn-refresh text-white" onClick={this.refreshData}><i className="fa fa-refresh" aria-hidden="true"/></Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <CardBox styleName="col-12 col-sm-12 col-lg-6 col-centered map-height" heading="Device Distribution by Region">
                            <SymbioticMarkerClusterer
                                markerData={this.state.deviceData.MapData ? this.state.deviceData.MapData : []}
                                onBoundsChanged={(bounds) => this.onBoundsChanged(bounds)}/>
                        </CardBox>
                        <div className="col-12 col-sm-12 col-lg-6">
                            <div className="row card-height">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="jr-card">
                                        <div className="row h-100 ">
                                            <div className="row mx-0">
                                                <div className="jr-card-header ml-2 mb-0">
                                                    <h3 className="card-heading d-inline-block"> Number Of Devices Deployed </h3>
                                                </div>
                                            </div>
                                            <div className="row w-100 mx-0">
                                                <div className="inner-height">
                                                    <div className="col-12 jr-card-body set-background">

                                                        <div className="info-card d-inline-flex w-100">
                                                            <div className="col left-text w-50 float-left px-0">
                                                                <h5 className="t-cost">
                                                                    {this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevices : 0}
                                                                </h5>
                                                            </div>
                                                            <div className="col text-right w-50 float-right px-0">
                                                                <img src="../../../../../assets/images/ico-device.png" alt=""/>
                                                            </div>
                                                        </div>
                                                        {this.state.deviceData.Summary && this.state.deviceData.MetaData ?
                                                            <p className="t-blue mb-0"> {this.getPercentDevices()}% of total devices.<br/></p> : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="jr-card">
                                        <div className="row h-100">
                                            <div className="row mx-0">
                                                <div className="jr-card-header ml-2"><h3 className="card-heading d-inline-block"> Number Of Techs Onsite </h3>
                                                </div>
                                            </div>
                                            <div className="row w-100 mx-0">
                                                <div className="inner-height">
                                                    <div className="col-12 jr-card-body set-background">
                                                        <div className="info-card d-inline-flex w-100">
                                                            <div className="col left-text w-50 float-left px-0">
                                                                <h5 className="t-cost">
                                                                    {this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredTechOnsite : 0}
                                                                </h5>
                                                            </div>
                                                            <div className="col text-right w-50 float-right px-0">
                                                                <img src="../../../../../assets/images/hse.png" alt=""/>
                                                            </div>
                                                        </div>
                                                        {this.state.deviceData.Summary && this.state.deviceData.MetaData ?
                                                            <p className="t-blue mb-0">{this.getPercentTechOnsite()}% of total devices with notification visited.<br/></p> : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="jr-card">
                                        <div className="row h-100">
                                            <div className="row mx-0">
                                                <div className="jr-card-header ml-2"><h3 className="card-heading d-inline-block"> Number Of Devices with Active Notifications </h3>
                                                </div>
                                            </div>
                                            <div className="row w-100 mx-0">
                                                <div className="inner-height">
                                                    <div className="col-12 jr-card-body set-background">
                                                        <div className="info-card d-inline-flex w-100">
                                                            <div className="col left-text w-50 float-left px-0">
                                                                <h5 className="t-cost">
                                                                    {this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevicesWithActiveNotificaion : 0}
                                                                </h5>
                                                            </div>
                                                            <div className="col text-right w-50 float-right px-0">
                                                                <img src="../../../../../assets/images/ico-notification.png" alt=""/>
                                                            </div>
                                                        </div>
                                                        {this.state.deviceData.Summary && this.state.deviceData.MetaData ?
                                                            <p className="t-blue mb-0">{this.getPercentActiveNotifications()}% of total Devices with Active notifications.<br/></p> : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="jr-card">
                                        <div className="row h-100">
                                            <div className="row mx-0">
                                                <div className="jr-card-header ml-2"><h3 className="card-heading d-inline-block"> Number Of Devices with Closed Notifications </h3>
                                                </div>
                                            </div>
                                            <div className="row w-100 mx-0">
                                                <div className="inner-height">
                                                    <div className="col-12 jr-card-body set-background">
                                                        <div className="info-card d-inline-flex w-100">
                                                            <div className="col left-text w-50 float-left px-0">
                                                                <h5 className="t-cost">
                                                                    {this.state.deviceData.Summary ? this.state.deviceData.Summary.TotalFilteredDevicesWithClosedNotificaion : 0}
                                                                </h5>
                                                            </div>
                                                            <div className="col text-right w-50 float-right px-0">
                                                                <img src="../../../../../assets/images/ico-notification.png" alt=""/>
                                                            </div>
                                                        </div>
                                                        {this.state.deviceData.Summary && this.state.deviceData.MetaData ?
                                                            <p className="t-blue mb-0"> {this.getPercentClosedNotifications()}% of total Devices with Closed Notifications.<br/></p> : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="jr-card">
                                        <div className="jr-card-header">
                                            <h3 className="card-heading d-inline-block"> Gas </h3>
                                        </div>
                                        <div className="jr-card-body">
                                            <div id="gaschart">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jr-card">
                                        <div className="jr-card-header">
                                            <h3 className="card-heading d-inline-block"> Flooding </h3>
                                        </div>
                                        <div className="jr-card-body">
                                            <div id="floodingChart">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jr-card">
                                        <div className="jr-card-header">
                                            <h3 className="card-heading d-inline-block"> Security Chart </h3>
                                        </div>
                                        <div className="jr-card-body">
                                            <div id="securityChart">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jr-card">
                                        <div className="jr-card-header">
                                            <h3 className="card-heading d-inline-block"> Tech On Site </h3>
                                        </div>
                                        <div className="jr-card-body">
                                            <div id="techOnSite">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="jr-card">
                                                <div className="jr-card-header">
                                                    <h3 className="card-heading d-inline-block"> Device Distribution by Technology Type </h3>
                                                </div>
                                                <div className="jr-card-body">
                                                    <div id="deviceDistributionChart">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="jr-card">
                                                <div className="jr-card-header">
                                                    <h3 className="card-heading d-inline-block"> Device Split by Access Type </h3>
                                                </div>
                                                <div className="jr-card-body">
                                                    <div id="deviceSplitByAccessType">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-lg-4">
                                    <div className="jr-card">
                                        <div className="jr-card-header">
                                            <h3 className="card-heading d-inline-block"> Devices by SDP/RSP Type </h3>
                                        </div>
                                        <div className="jr-card-body">
                                            <div id="sdpChart">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                </div>
            </div>
        );
    }
}

export default Devices;


// WEBPACK FOOTER //
// ./app/routes/devices/index.js